import { LoadingButton } from '@mui/lab';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

const defaultValues = {
  searchTerm: '',
  quantity: '',
};

const ProductAddDialog = ({
  open,
  onClose,
  loading,
  step,
  onBackToSearch,
  onSearchTermChange,
  searchResults,
  searchLoading,
  packages,
  selectedProduct,
  selectedPack,
  onSelectProduct,
  onSelectPack,
  onInsert,
  operationType, // "entry" | "departure" | "transfer",
  onQuantityChange,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitted },
  } = useForm({
    defaultValues,
  });

  useEffect(() => {
    if (open) {
      reset(defaultValues);
    }
  }, [open, reset]);

  const onSubmit = data => {
    onInsert(data.quantity);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={step === 'search' ? 'md' : 'sm'}
      sx={{ direction: 'rtl' }}
    >
      <DialogTitle>افزودن محصول</DialogTitle>

      <DialogContent sx={{ minHeight: '100px' }}>
        {step === 'search' ? (
          <Stack gap={1.5} pt={1}>
            <TextField
              autoFocus
              label="جستجوی محصول"
              {...register('searchTerm', {
                onChange: event => {
                  onSearchTermChange(event.target.value);
                },
              })}
            />

            {searchLoading ? (
              <CircularProgress size={22} sx={{ mx: 'auto' }} />
            ) : null}

            {searchResults.map(item => {
              const disabled =
                !(item.quantity > 0) && operationType !== 'entry';

              return (
                <Box
                  key={item.guid}
                  onClick={disabled ? undefined : () => onSelectProduct(item)}
                  sx={{
                    flex: 1,
                    backgroundColor: '#F0F2F3',
                    borderRadius: '8px',
                    px: 2,
                    py: 1.5,
                    display: 'flex',
                    justifyContent: 'space-between',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    opacity: disabled ? 0.5 : 1,
                    pointerEvents: disabled ? 'none' : 'auto',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      gap: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 14,
                        color: '#434343',
                      }}
                    >
                      {item.title}
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 14,
                        color: '#434343',
                      }}
                    >
                      ({item.code})
                    </Typography>
                  </Box>

                  <Typography
                    sx={{
                      fontSize: 14,
                      color: '#434343',
                    }}
                  >
                    موجودی: {item.quantity}
                  </Typography>
                </Box>
              );
            })}
          </Stack>
        ) : null}

        {step === 'pack' ? (
          <Stack gap={1.5} pt={1}>
            <Typography>بسته را انتخاب کنید</Typography>

            {packages.map(pack => (
              <Button
                key={pack.guid}
                variant="contained"
                onClick={() => onSelectPack(pack)}
              >
                {pack.name}

                <Typography sx={{ fontSize: 14, mr: 1 }}>
                  (موجودی: {pack.quantity})
                </Typography>
              </Button>
            ))}

            <Button onClick={onBackToSearch}>بازگشت</Button>
          </Stack>
        ) : null}

        {step === 'qty' ? (
          <Stack gap={1.5} pt={1}>
            <Typography>
              {selectedProduct?.title} - {selectedPack?.name}
            </Typography>

            <Typography sx={{ fontSize: 14, mr: 1 }}>
              موجودی: {selectedProduct?.quantity}
            </Typography>

            <TextField
              label="تعداد"
              type="number"
              {...register('quantity', {
                required: 'تعداد الزامی است',
                setValueAs: value => (value === '' ? '' : Number(value)),
                validate: value => {
                  if (value <= 0) {
                    return 'تعداد باید بیشتر از صفر باشد';
                  }

                  if (
                    operationType !== 'entry' &&
                    value > selectedProduct?.quantity
                  ) {
                    return 'مقدار وارد شده نمی‌تواند از موجودی محصول بیشتر باشد.';
                  }

                  return true;
                },
                onChange: event => {
                  onQuantityChange(event.target.value);
                },
              })}
              error={isSubmitted ? !!errors.quantity : null}
              helperText={errors.quantity?.message}
            />
          </Stack>
        ) : null}
      </DialogContent>

      <DialogActions sx={{ gap: 1, p: 2 }}>
        <Button onClick={onClose} disabled={loading}>
          انصراف
        </Button>

        {step === 'qty' ? (
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={handleSubmit(onSubmit)}
          >
            ثبت
          </LoadingButton>
        ) : null}
      </DialogActions>
    </Dialog>
  );
};

export default ProductAddDialog;
